/**
 * Bitmart timeframe configuration and interval mapping.
 * REST uses step in minutes: 1, 5, 15, 30, 60, 120, 240, 1440, 10080, 43200.
 * @see https://developer-pro.bitmart.com/en/spot/#get-k-line-v3
 */

import {
  registerExchangeTimeframes,
  resolutionToSeconds,
  type TimeframeConfig,
} from '../../lib/timeframes';

/**
 * Bitmart supported kline intervals.
 */
export const BITMART_TIMEFRAMES: TimeframeConfig = {
  native: ['1m', '5m', '15m', '30m', '1h', '2h', '4h', '1d', '1w', '1M'],
  synthetic: ['1s'],
  minIntervalSeconds: 60,
};

// Register with central registry
registerExchangeTimeframes('bitmart', BITMART_TIMEFRAMES);

/**
 * Maps TradingView resolution to Bitmart interval format.
 */
export const mapToBitmartInterval = (resolution: string): string => {
  const seconds = resolutionToSeconds(resolution);

  if (seconds < 60) return '1m';
  if (seconds === 60) return '1m';
  if (seconds === 300) return '5m';
  if (seconds === 900) return '15m';
  if (seconds === 1800) return '30m';
  if (seconds === 3600) return '1h';
  if (seconds === 7200) return '2h';
  if (seconds === 14400) return '4h';
  if (seconds === 86400) return '1d';
  if (seconds === 604800) return '1w';
  if (seconds === 2592000) return '1M';

  if (seconds < 300) return '1m';
  if (seconds < 900) return '5m';
  if (seconds < 1800) return '15m';
  if (seconds < 3600) return '30m';
  if (seconds < 7200) return '1h';
  if (seconds < 14400) return '2h';
  if (seconds < 86400) return '4h';
  if (seconds < 604800) return '1d';
  if (seconds < 2592000) return '1w';

  return '1M';
};
